import React from "react";
import AdminPageShell from "./AdminPageShell";

const AdminProfile = () => {
  return (
    <AdminPageShell
      active="profile"
      title="Admin Profile"
      text="Manage super admin account details and password."
    >
      <div className="row">
        <div className="col-lg-7">
          <div className="ls-widget">
            <div className="widget-title"><h4>Profile Details</h4></div>
            <div className="widget-content">
              <form className="default-form" onSubmit={(e) => e.preventDefault()}>
                <div className="row">
                  <div className="form-group col-lg-6 col-md-12">
                    <label>Full Name</label>
                    <input type="text" defaultValue="Super Admin" />
                  </div>
                  <div className="form-group col-lg-6 col-md-12">
                    <label>Email</label>
                    <input type="email" defaultValue="admin@epic-jobs.com" />
                  </div>
                  <div className="form-group col-lg-12">
                    <button type="submit" className="theme-btn btn-style-one">Save Profile</button>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
        <div className="col-lg-5">
          <div className="ls-widget">
            <div className="widget-title"><h4>Change Password</h4></div>
            <div className="widget-content">
              <form className="default-form" onSubmit={(e) => e.preventDefault()}>
                <div className="form-group">
                  <label>Current Password</label>
                  <input type="password" placeholder="Current password" />
                </div>
                <div className="form-group">
                  <label>New Password</label>
                  <input type="password" placeholder="New password" />
                </div>
                <button type="submit" className="theme-btn btn-style-three">Update Password</button>
              </form>
            </div>
          </div>
        </div>
      </div>
    </AdminPageShell>
  );
};

export default AdminProfile;
